import request from '../utils/request';

//登录
export function login(data) {
  return request({
    url: 'wap/tyUser/login.html',
    method: 'post',
    data
  })
}

//注册提交
export function doRegister(data) {
  return request({
    url: 'wap/tyUser/doRegister.html',
    method: 'post',
    data
  })
}

//获取地区
export function toArea(data) {
  return request({
    url: 'wap/tyUser/toArea.html',
    method: 'get',
    params:data
  })
}

//获取图片验证码
export function captchaImage(data) {
  return request({
    url: 'wap/catch/captchaImage.html',
    method: 'get',
    params:data
  })
}

//获取手机号验证码
export function sendDx(data) {
  return request({
    url: 'wap/tyUser/sendDx.html',
    method: 'post',
    data
  })
}

//校验学员手机号唯一性
export function toOnlyUser(data) {
  return request({
    url: 'wap/tyUser/toOnlyUser.html',
    method: 'post',
    data
  })
}

//校验图片验证码
export function checkCatchCode(data) {
  return request({
    url: 'wap/catch/checkCatchCode.html',
    method: 'post',
    data
  })
}
//获取移动端地址
export function isMobile(data) {
  return request({
    url: '/wap/tyUser/isMobile.html',
    method: 'post',
    data
  });
}